import GroupCard from "../../../components/Cards/GroupCard";
import type { GroupProgress } from "../../../configs/apis/models";
import { Operator } from "../../../configs/models/constants";

export type GroupsDrawerProps = {
  groupProgress: GroupProgress[];
};

const GroupsDrawer = ({ groupProgress }: GroupsDrawerProps) => {
  return (
    <div className="flex flex-col gap-8">
      {groupProgress?.map((group, idx) => (
        <>
          <GroupCard key={group.groupId} triggers={group.triggersProgress} />
          {idx !== groupProgress.length - 1 && (
            <div className="flex items-center gap-4">
              <div className="h-[2px] w-full bg-foreground-lighter/70" />
              <span className="font-semibold text-foreground-lighter/70">
                {group.operator === Operator.AND ? "And" : "Or"}
              </span>
              <div className="h-[2px] w-full bg-foreground-lighter/70" />
            </div>
          )}
        </>
      ))}
    </div>
  );
};

export default GroupsDrawer;
